export const envVars = {
	api: {
		headers: {
			accept: '%%%REACT_APP_API_HEADER_ACCEPT%%%',
			'ocp-apim-subscription-key': '%%%REACT_APP_API_HEADER_OCP_APIM_SUBSCRIPTION_KEY%%%',
			'content-type': '%%%REACT_APP_API_HEADER_CONTENT_TYPE%%%',
		},
		url: '%%%REACT_APP_API_URL%%%',
	},
	logger: {
		debug: '%%%REACT_APP_LOGGER_DEBUG%%%',
		error: '%%%REACT_APP_LOGGER_ERROR%%%',
		log: '%%%REACT_APP_LOGGER_LOG%%%',
	},
	auth: {
		active: '%%%REACT_APP_AUTH_ACTIVE%%%',
		clientId: '%%%REACT_APP_AUTH_CLIENT_ID%%%',
		authority: '%%%REACT_APP_AUTH_AUTHORITY%%%',
		redirectUri: '%%%REACT_APP_AUTH_REDIRECT_URI%%%',
		apiScope: '%%%REACT_APP_AUTH_API_SCOPE%%%',
	},
};
